import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { ApplicationForm } from '../Forms/ApplicationForm'
import { RestSchemas } from '@/contexts/QueryProvider'
import { MaintainAppAdminsForm } from '../Forms/MaintainAppAdminsForm'
import { useNavigate } from 'react-router'
import { AppAttributesFormV2 } from '../Forms/AppAttributesFormV2'
// import { useCanEditApp } from '@/util/permissions'

type MessagesApplicationsApplication = RestSchemas['Messages.Applications.Application']

export function CardActionsMenu({ app }: { app: MessagesApplicationsApplication }) {
  const navigate = useNavigate()
  // const canEditApp = useCanEditApp()

  return (
    <>
      <DropdownMenu
        onOpenChange={(open) => {
          // This is necessary to maintain the open state when we want to keep it open
          if (!open) {
            // Check if we need to prevent closing
            // This is a placeholder for custom logic you might need
            // We'll use other mechanisms to prevent closing on item click
          }
        }}
      >
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" className="size-8 rounded-full">
            <IconMenuOutline size={16} />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          onCloseAutoFocus={(e) => {
            // Prevent focus returning to trigger which can close the menu
            e.preventDefault()
          }}
        >
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {/* <DropdownMenuItem onSelect={() => null}>Edit application</DropdownMenuItem> */}
          <ApplicationForm
            selectedApp={app}
            sheetTitle={`${app.appName} ► Edit details`}
            sheetDescription="Edit the details of the application."
            sheetTrigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Edit</DropdownMenuItem>}
          />
          <AppAttributesFormV2
            selectedApp={app}
            sheetTitle={`${app.appName} ► Edit attributes`}
            sheetDescription="Edit the attributes of the application."
            sheetTrigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Edit attributes</DropdownMenuItem>}
          />
          {/* <DropdownMenuItem onSelect={() => navigate(`/applications/${app.appKey}/marketing`)}>
            Edit attributes
          </DropdownMenuItem> */}
          <MaintainAppAdminsForm
            selectedApp={app}
            sheetTitle={`${app.appName} ► Manage administrators`}
            sheetDescription="Manage the administrators of the application."
            sheetTrigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Administrators</DropdownMenuItem>}
          />
          <DropdownMenuItem onSelect={() => navigate(`/applications/${app.appKey}/accesses`)}>
            Accesses
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
